import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { windowTime } from 'rxjs/operator/windowTime';
import { ToasterService } from 'angular2-toaster';
import { WebServiceService } from '../../shared/services/web-service.service';
import { IrFieldsService } from '../../shared/services/ir-fields.service';
import { LocalStorageService } from '../../shared/services/storage/local-storage.service';
import { Router } from "@angular/router";
import { Title } from '@angular/platform-browser';
import { CompanySetupService } from '../../shared/services/company-setup.service';
import { EesDesService } from '../../shared/services/ees-des.service';
import * as jsPDF from 'jspdf';
import * as _html2canvas from "html2canvas";
@Component({
  selector: 'app-generic-modal-popup',
  templateUrl: './generic-modal-popup.component.html',
  styleUrls: ['./generic-modal-popup.component.scss'],
  providers:[CompanySetupService,WebServiceService,IrFieldsService]

})
export class GenericModalPopupComponent implements OnInit {
  @Input() modalDetails: any;
  @Output()
  sendAction = new EventEmitter()
  commonVariableList: any = {
    "actionsList": [{
      "name": "View",
      "icon": "fa fa-eye",
      "action": "view"
    }],
    "dataList": [],
    "columnList": [],
    "afterdivList": [],
    "beforedivList": [],
    "isProgressing": true,
    "modalDetails": {},
    "dataDetails": {},
    "tableDetails": {is_setup:false,setup:{}},
    "attachments": [],
    "approvalDetails": {is_setup:false,setup:{}},
    "afterDivDetails": {is_setup:false,setup:{}},
    "beforeDivDetails": {is_setup:false,setup:{}},
    "allocableCostDetails": {is_setup:false,setup:{},is_view:false},
    "is_history":false,
    "historyList":[],
    "additional_attachment": {'title':'','attachment':[]},
    "contractualPoAttachments": {'title':'Attach Signed Contract Copy','attachment':[]},
    "fulfilled_po_upload_invoice": [],
    "fulfilled_po_upload_invoice_title": '',
    "fulfilled_po_vendor_attachment": [],
    "fulfilled_po_vendor_attachment_title": '',
    "is_allocable_cost": false,
    "allocableCostLines": [],
    "document_currency_code": '',
  };
  is_recurring:boolean=false
  page_url:any=window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
  irn_to_grn: any;
  grn_to_qc: any;
  constructor(public eesdesService:EesDesService,public webService: WebServiceService,
    public irFields: IrFieldsService,
    private toasterService: ToasterService,
    public _localStorageService: LocalStorageService,
    private router: Router, private titleService: Title,public comanySetup:CompanySetupService ) {
    this.initListener();

  }
  company_setup: any = {};
  country_data:any={}
  setup:any={}
modal_setup:any={}
companyThemeBlockColor: any = "";
CompanyThemetextColor: any = "";

  // Product master (view-only) support for PR module hyperlink
  visibleProductMaster: any = { isCreateVisible: false, isViewVisible: true, isProgressing: false };
  isViewModeProductMaster: boolean = true;

  // Variables to match master Product UI template
  visible: any = this.visibleProductMaster;
  isViewMode: boolean = true;
  productData: any[] = [];
  companySelectionDisabled: boolean = true;
  isEmpCodeDisable: boolean = true;
  showErpVar: boolean = true;
  isApproverEdit: boolean = false;

  // Minimal dropdown lists (filled from response for view-only)
  UnitTypeList: any[] = [];
  hsncodelist: any[] = [];
  typeList: any[] = [];
  typeList2: any[] = [];
  productCategory: any[] = [];
  productSubCategory: any[] = [];
  accountCodeList: any[] = [];
  qcList: any[] = [];
  tdsList: any[] = [];
  approvalList: any[] = [];

  // Search models used by md2-select headers
  searcUnitType: string = '';
  searchHsn: string = '';
  searchProductType2: string = '';
  searcCategoryType: string = '';
  searcSubCategoryType: string = '';
  searchAccountType: string = '';
  searchconsumption_stock_account: string = '';
  searchnon_boq_production_stock_account: string = '';
  searchQC: string = '';
  searchTdsList: string = '';
  searchApproval: string = '';
  approval: any = '';
  savedFiles: any[] = [];
  isUploading: boolean = false;
  ngOnInit() {
    let t:any={};
    t = this.eesdesService.get('country_data',localStorage.getItem('country_data')) ? this.eesdesService.get('country_data',localStorage.getItem('country_data')) : {};
    console.log(t);
    if(t.country_id!==''&&t.country_id!==undefined&&t.country_id!==null)
    {
      this.country_data=t;
    }
    this.setup=this.modalDetails.setup?this.modalDetails.setup:{}
      this.setup.is_setup=this.modalDetails.is_setup?this.modalDetails.is_setup:false;

    if(this.setup.is_setup)
    {
            this.modal_setup=this.setup;
      this.comanySetup.setData(this.modal_setup);
      this.setSetupData(this.setup);
    }
    else
    {
          this.GetCompanySetUpData();
    }
    this.companyThemeBlockColor = this._localStorageService.getCompanyTheme() ? this._localStorageService.getCompanyTheme() : "#035168";
   this.CompanyThemetextColor = this._localStorageService.getCompanyThemeColor() ? this._localStorageService.getCompanyThemeColor() : "#FFFFFF";
  }
  GetCompanySetUpData() {
    if (this.company_setup.product_catalog_id != undefined && this.company_setup.product_catalog_id != '')
{
  return false;
}
    let req:any={}
    this.company_setup={}
    this.webService.commonPostMethod("Update_company_meta/ajax_getall_bycompany", req).subscribe(
      data => {
        if (data.status) {
          this.company_setup.comma_separate_currency_code = this.company_setup.comma_separate_currency_code ? this.company_setup.comma_separate_currency_code : 'IND';
          this.company_setup.is_enable_comma_separate_price = this.company_setup.is_enable_comma_separate_price ? this.company_setup.is_enable_comma_separate_price : '0';
          this.company_setup.enable_parallel_approver_in_dc_note_module = this.company_setup.enable_parallel_approver_in_dc_note_module ? this.company_setup.enable_parallel_approver_in_dc_note_module : '0';
          this.company_setup.questionnaire_upload_table_in_irn = this.company_setup.questionnaire_upload_table_in_irn ? this.company_setup.questionnaire_upload_table_in_irn : [];
          this.company_setup.enable_questionnarie_files = this.company_setup.enable_questionnarie_files ? this.company_setup.enable_questionnarie_files : "0";
          this.company_setup.upload_file_for_custom_name = this.company_setup.upload_file_for_custom_name ? this.company_setup.upload_file_for_custom_name : 'Custom name Upload File';
          this.company_setup.its_note_visibale = this.company_setup.its_note_visibale ? this.company_setup.its_note_visibale : 'Note';
         
          this.company_setup.enable_po_additional_attachment_display_in_po_hyperlink = this.company_setup.enable_po_additional_attachment_display_in_po_hyperlink ? this.company_setup.enable_po_additional_attachment_display_in_po_hyperlink : "0";

          this.setSetupData(data.response);
      }
      }, error => {

      }
    )
  }
  setSetupData(data)
  {
          this.company_setup=data ? data : {}
          this.company_setup.allow_post_payment_debit_note_in_dc_note = this.company_setup.allow_post_payment_debit_note_in_dc_note ? this.company_setup.allow_post_payment_debit_note_in_dc_note : '0';
          this.company_setup.product_catalog_id = this.company_setup.product_catalog_id ? this.company_setup.product_catalog_id : '';
          if (this.company_setup.product_catalog_id != undefined && this.company_setup.product_catalog_id != '') {
            this.company_setup.product_catalog_id = '1'
          }
          // this.company_setup.product_catalog_id = this.company_setup.product_catalog_id ? this.company_setup.product_catalog_id : '0';
          this.company_setup.merge_grn_irn = this.company_setup.merge_grn_irn ? this.company_setup.merge_grn_irn : '0';
          this.company_setup.enable_free_quantity_in_po = this.company_setup.enable_free_quantity_in_po ? this.company_setup.enable_free_quantity_in_po : '0';
          this.company_setup.has_multi_grn_approval = this.company_setup.has_multi_grn_approval ? this.company_setup.has_multi_grn_approval : '0';
          this.company_setup.is_delivery_cc_visible = this.company_setup.is_delivery_cc_visible ? this.company_setup.is_delivery_cc_visible : '0';
          this.company_setup.is_delivery_cc_visible_po = this.company_setup.is_delivery_cc_visible_po ? this.company_setup.is_delivery_cc_visible_po : "0";
          this.company_setup.show_lob_dropdown = this.company_setup.show_lob_dropdown ? this.company_setup.show_lob_dropdown : '0';
          this.company_setup.show_loc_dropdown = this.company_setup.show_loc_dropdown ? this.company_setup.show_loc_dropdown : '0';
          this.company_setup.show_dept_dropdown = this.company_setup.show_dept_dropdown ? this.company_setup.show_dept_dropdown : '0';

          this.company_setup.is_bm_visible_in_allocate_costcenter_in_inv = this.company_setup.is_bm_visible_in_allocate_costcenter_in_inv ? this.company_setup.is_bm_visible_in_allocate_costcenter_in_inv : '0';
          this.company_setup.is_sppartner_visible_in_allocate_costcenter_in_inv = this.company_setup.is_sppartner_visible_in_allocate_costcenter_in_inv ? this.company_setup.is_sppartner_visible_in_allocate_costcenter_in_inv : '0';
          this.company_setup.is_emp_no_dd_visible_in_allocate_costcenter_in_inv = this.company_setup.is_emp_no_dd_visible_in_allocate_costcenter_in_inv ? this.company_setup.is_emp_no_dd_visible_in_allocate_costcenter_in_inv : '0';
          this.company_setup.is_cc_disabled_in_allocate_costcenter_in_inv = this.company_setup.is_cc_disabled_in_allocate_costcenter_in_inv ? this.company_setup.is_cc_disabled_in_allocate_costcenter_in_inv : '0';
          this.company_setup.hide_numaric_number_in_lob_loc_dep = this.company_setup.hide_numaric_number_in_lob_loc_dep ? this.company_setup.hide_numaric_number_in_lob_loc_dep : '0';
          this.company_setup.po_expiry_date_visible = this.company_setup.po_expiry_date_visible ? this.company_setup.po_expiry_date_visible : "0";
          this.company_setup.custom_name_for_po_expiry_date = this.company_setup.custom_name_for_po_expiry_date ? this.company_setup.custom_name_for_po_expiry_date : "0";
          this.company_setup.po_expiry_date_mandatory = this.company_setup.po_expiry_date_mandatory ? this.company_setup.po_expiry_date_mandatory : "0";
          this.company_setup.is_accepted_qty_hidden = false;
          this.company_setup.is_paid_price_hidden = false;
          this.company_setup.is_total_paid_price_hidden = false;
          this.company_setup.is_difference_price_hidden = false;
          this.company_setup.is_total_difference_price_hidden = false;
          this.company_setup.is_total_price_hidden = false;
          // this.company_setup.is_product_description_hidden = false;
          this.company_setup.is_product_type_hidden = false;
          this.company_setup.is_unit_type_hidden = false;
          this.company_setup.is_remarks_hidden = false;
          this.company_setup.in_invoice_date_format = this.company_setup.in_invoice_date_format ? this.company_setup.in_invoice_date_format : "";

          this.company_setup.is_paid_cgst_hidden = false;
          this.company_setup.is_paid_sgst_hidden = false;
          this.company_setup.is_paid_igst_hidden = false;
          this.company_setup.is_total_paid_price_gst_hidden = false;
          this.company_setup.direct_invoice_columnList = this.company_setup.direct_invoice_columnList ? this.company_setup.direct_invoice_columnList : []
          if (this.company_setup.direct_invoice_columnList.length > 0) {
            this.company_setup.is_accepted_qty_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'accepted_qty' && v.isVisible });
            this.company_setup.is_paid_price_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'paid_price' && v.isVisible });
            this.company_setup.is_total_paid_price_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'total_paid_price' && v.isVisible });
            this.company_setup.is_difference_price_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'difference_price' && v.isVisible });
            this.company_setup.is_total_difference_price_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'total_difference_price' && v.isVisible });
            this.company_setup.is_total_price_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'total_price' && v.isVisible });
            // this.company_setup.is_product_description_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'product_description' && v.isVisible });
            this.company_setup.is_product_type_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'product_type' && v.isVisible });
            this.company_setup.is_unit_type_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'unit_type' && v.isVisible });
            this.company_setup.is_remarks_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'remarks' && v.isVisible });
            this.company_setup.is_paid_cgst_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'paid_cgst' && v.isVisible });
            this.company_setup.is_paid_sgst_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'paid_sgst' && v.isVisible });
            this.company_setup.is_paid_igst_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'paid_igst' && v.isVisible });
            this.company_setup.is_total_paid_price_gst_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'total_paid_price_gst' && v.isVisible });
          }

          this.company_setup.in_add_invoice_accepted_qty_hidden = false;
          this.company_setup.in_add_invoice_paid_price_hidden = false;
          this.company_setup.in_add_invoice_total_paid_price_hidden = false;
          this.company_setup.in_add_invoice_difference_price_hidden = false;
          this.company_setup.in_add_invoice_total_difference_price_hidden = false;
          this.company_setup.in_add_invoice_total_price_hidden = false;
          this.company_setup.in_add_invoice_product_type_hidden = false;
          this.company_setup.in_add_invoice_unit_type_hidden = false;
          this.company_setup.in_add_invoice_remarks_hidden = false;
          this.company_setup.in_add_invoice_paid_cgst_hidden = false;
          this.company_setup.in_add_invoice_paid_sgst_hidden = false;
          this.company_setup.in_add_invoice_paid_igst_hidden = false;
          this.company_setup.in_add_invoice_total_paid_price_gst_hidden = false;
          this.company_setup.in_add_invoice_rejected_qty_hidden = false;

          this.company_setup.add_invoice_columnList = this.company_setup.add_invoice_columnList ? this.company_setup.add_invoice_columnList : []
          if (this.company_setup.add_invoice_columnList.length > 0) {
            this.company_setup.in_add_invoice_accepted_qty_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'accepted_qty' && v.isVisible });
            this.company_setup.in_add_invoice_paid_price_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'paid_price' && v.isVisible });
            this.company_setup.in_add_invoice_total_paid_price_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'total_paid_price' && v.isVisible });
            this.company_setup.in_add_invoice_difference_price_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'difference_price' && v.isVisible });
            this.company_setup.in_add_invoice_total_difference_price_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'total_difference_price' && v.isVisible });
            this.company_setup.in_add_invoice_total_price_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'total_price' && v.isVisible });
            this.company_setup.in_add_invoice_product_type_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'product_type' && v.isVisible });
            this.company_setup.in_add_invoice_unit_type_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'unit_type' && v.isVisible });
            this.company_setup.in_add_invoice_remarks_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'remarks' && v.isVisible });
            this.company_setup.in_add_invoice_paid_cgst_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'paid_cgst' && v.isVisible });
            this.company_setup.in_add_invoice_paid_sgst_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'paid_sgst' && v.isVisible });
            this.company_setup.in_add_invoice_paid_igst_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'paid_igst' && v.isVisible });
            this.company_setup.in_add_invoice_total_paid_price_gst_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'total_paid_price_gst' && v.isVisible });
            this.company_setup.in_add_invoice_rejected_qty_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'rejected_qty' && v.isVisible });
          }

          this.company_setup.invoice_raiser_hide_tds = this.company_setup.invoice_raiser_hide_tds ? this.company_setup.invoice_raiser_hide_tds : '0';
          if(this.page_url != 'all-invoices' && this.page_url != 'draft-invoice') {
            this.company_setup.invoice_raiser_hide_tds = '0';
          }
          this.company_setup.pr_customer_custom_name = this.company_setup.pr_customer_custom_name ? this.company_setup.pr_customer_custom_name : 'Customer';
          this.company_setup.is_budget_selection_at_item_level_in_product_table = this.company_setup.is_budget_selection_at_item_level_in_product_table ? this.company_setup.is_budget_selection_at_item_level_in_product_table : '0';
          this.company_setup.rename_project = this.company_setup.rename_project ? this.company_setup.rename_project : 'Project';
          this.company_setup.rename_task = this.company_setup.rename_task ? this.company_setup.rename_task : 'Task';
          this.company_setup.is_different_document_currency = this.company_setup.is_different_document_currency ? this.company_setup.is_different_document_currency : 'Is DDC';
          this.company_setup.pdf_option_in_all_approved_inv=this.company_setup.pdf_option_in_all_approved_inv?this.company_setup.pdf_option_in_all_approved_inv:'0',
          this.company_setup.modified_irn_to_grn = this.company_setup.modified_irn_to_grn ? this.company_setup.modified_irn_to_grn : '0';
          this.irn_to_grn = (this.company_setup.modified_irn_to_grn == 1) ? "GRN" : "IRN";
          this.company_setup.modified_grn_to_qc = this.company_setup.modified_grn_to_qc ? this.company_setup.modified_grn_to_qc : '0';
          this.grn_to_qc = (this.company_setup.modified_grn_to_qc == 1) ? "QC" : "GRN";
          this.company_setup.attachments_visible_raise_po = this.company_setup.attachments_visible_raise_po ? this.company_setup.attachments_visible_raise_po : '0';
          this.company_setup.enable_ddc_in_pr = this.company_setup.enable_ddc_in_pr ? this.company_setup.enable_ddc_in_pr : '0';
          this.company_setup.show_voucher_type_in_inv = this.company_setup.show_voucher_type_in_inv ? this.company_setup.show_voucher_type_in_inv : "0";
          this.company_setup.is_show_vendor_at_pr_level = this.company_setup.is_show_vendor_at_pr_level ? this.company_setup.is_show_vendor_at_pr_level : '0';
          this.company_setup.is_vendor_editable_in_pr_approver = this.company_setup.is_vendor_editable_in_pr_approver ? this.company_setup.is_vendor_editable_in_pr_approver : '0';
          this.company_setup.vendor_invoice_column_list=this.company_setup.vendor_invoice_column_list?this.company_setup.vendor_invoice_column_list:[];
          this.company_setup.irn_number_editable = this.company_setup.irn_number_editable ? this.company_setup.irn_number_editable : '0';
          this.modal_setup = this.company_setup;
          this.comanySetup.setData(this.modal_setup);

          if (this.modalDetails.data) {
            this.apiCall();
          }
          document.getElementById('body').style.overflow = 'hidden';

  }
  apiCall() {
    this.commonVariableList.is_history=this.modalDetails.is_history?this.modalDetails.is_history:false;
    switch (this.modalDetails.id) {
      case 'productmaster':
        this.modalDetails.name = this.modalDetails.name ? this.modalDetails.name : 'Product Master Details';
        this.showProductMaster(this.modalDetails.data);
        break;
      case 'invoicepaymentreport':
        this.showInvoicePayment(this.modalDetails.data);
        break;
        case 'adhocpaymentreport':
          this.showAdhocPayment(this.modalDetails.data);
          break;
        case 'invoice_android_report':
          this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/generate-invoice-android');

        this.showAndroidInvoice(this.modalDetails.data);
        break;
        case 'recurring_invoicereport':
          this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/create-curring-inv');
        this.is_recurring=this.page_url=='auto-generated-inv'
        this.showRecurringInvoice(this.modalDetails.data);
        break;
      case 'invoicereport':
          this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/add-invoice-v2');

        this.showInvoice(this.modalDetails.data);
        break;
      case 'salesinvoicereport':
        this.showSalesInvoice(this.modalDetails.data);
        break;
      case 'grnreport':
          this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/add-grn');

        this.showGrn(this.modalDetails.data);
        break;
      case 'irnreport':
          this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/new-irn');

        this.showIrn(this.modalDetails.data);
        break;
      case 'poreport':
          this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/raise-po');

        this.showPo(this.modalDetails.data);
        break;
        case 'dcnotereport':
          this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/my-debit-credit');
        this.showDCNote(this.modalDetails.data);
        break;
      case 'prreport':
          this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/raisepr');

        this.showPr(this.modalDetails.data);
        break;
        case 'irreport':
            this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/raiseir');

          this.showIr(this.modalDetails.data);
          break;
          case 'ir_history_report':
            this.modalDetails.name="IR History"

          this.showIRHistory(this.modalDetails.data);
          break;
      case 'my_advance_report':
        this.showMyAdvance(this.modalDetails.data);
        break;
      case 'employee_advance_payment_report':
        this.showEmployeeAdvancePayment(this.modalDetails.data);
        break;
      case 'rfqNumberReport':
        this.showRfqData(this.modalDetails.data, "rfqNumberReport");
        break;
      case 'rfqResponseReport':
        this.showRfqData(this.modalDetails.data, "rfqResponseReport");
        break;
      case 'creditnotereport':
        this.modalDetails.name = "Vendor Credit Note";
        this.showVendorCreditNote(this.modalDetails.data,);
        break;
      default:
        this.toasterService.pop('error', "Error", "Wrong Data");
    }
  }

  getProductMasterData(): any {
    const tableDetails = this.commonVariableList.tableDetails;
    const items = tableDetails && tableDetails.data && tableDetails.data.items;
    return items && items.length ? items[0] : null;
  }

  getProductDataForView(): any[] {
    const p = this.getProductMasterData();
    return p ? [p] : [];
  }

  is_column_visible_productmaster(key: string, b: boolean): boolean {
    const list = this.company_setup && this.company_setup.product_master_column_list;
    if (list && list.length) {
      const col = list.find(function (c) { return c.key === key; });
      return col ? (col.isVisible !== false) : true;
    }
    return true;
  }

  getColumnName_productmaster(key: string, defaultName: string): string {
    const list = this.company_setup && this.company_setup.product_master_column_list;
    if (list && list.length) {
      const col = list.find(function (c) { return c.key === key; });
      return col && col.display ? col.display : defaultName;
    }
    return defaultName;
  }

  // Master template aliases
  is_column_visible(key: string, b: boolean): boolean { return this.is_column_visible_productmaster(key, b); }
  getColumnName(key: string, defaultName: string): string { return this.getColumnName_productmaster(key, defaultName); }

  showProductMaster(data: any) {
    this.commonVariableList.isProgressing = true;
    const payload: any = {
      company_id: this._localStorageService.getEmpCompanyId() == undefined ? '0' : this._localStorageService.getEmpCompanyId(),
      user_id: this._localStorageService.getUserId(),
      product_id: data && (data.product_id || data.id) ? (data.product_id || data.id) : '',
      cost_center_id: data && data.cost_center_id ? data.cost_center_id : '',
    };
    this.webService.commonPostMethod('companies/ajax_getproductbycompany_v2', payload).subscribe(
      resp => {
        if (resp && resp.status) {
          let product: any = resp.product ? resp.product : (resp.response ? resp.response : (resp.data ? resp.data : resp));
          if (product && product.length != undefined && product.length !== null) {
            product = product.length ? product[0] : {};
          }

          // Normalize to booleans for view-only toggles/checkboxes
          const productBoolKeys = ['product_status', 'auto_re_order', 'rcm_applicable', 'gst_not_applicable', 'equalization_levy_applicable', 'warranty', 'installation', 'is_active', 'is_sales_product', 'maintain_rack', 'impact_ageing_report', 'is_for_buy_account', 'is_for_sale_account'];
          productBoolKeys.forEach(k => { product[k] = product[k] == '1' || product[k] === 1 || product[k] === true; });

          // Alias keys to match master template names (price variance)
          product.allowed_price_variance_cvpp_to_po = product.allowed_price_variance_cvpp_to_po != undefined ? product.allowed_price_variance_cvpp_to_po : product.po_cvpp_allowed_price;
          product.allowed_price_variance_po_to_invoice = product.allowed_price_variance_po_to_invoice != undefined ? product.allowed_price_variance_po_to_invoice : product.po_invoice_allowed_price;
          product.allowed_price_variance_cvpp_to_direct_invoice = product.allowed_price_variance_cvpp_to_direct_invoice != undefined ? product.allowed_price_variance_cvpp_to_direct_invoice : product.cvpp_inv_allowed_price;

          // Normalize unit_types rows for checkbox UI
          product.unit_types = product.unit_types ? product.unit_types : [];
          if (product.unit_types && product.unit_types.length) {
            product.unit_types = product.unit_types.map(function (u) {
              u.searcUnitType = u.searcUnitType ? u.searcUnitType : '';
              u.is_default_buy_uae = u.is_default_buy_uae == '1' || u.is_default_buy_uae === 1 || u.is_default_buy_uae === true;
              u.is_default_sales_uae = u.is_default_sales_uae == '1' || u.is_default_sales_uae === 1 || u.is_default_sales_uae === true;
              u.is_default = u.is_default == '1' || u.is_default === 1 || u.is_default === true;
              return u;
            });
          }

          // Drive master-like UI variables
          this.visible = this.visibleProductMaster;
          this.isViewMode = true;
          this.productData = [product];

          // Populate minimal lists so disabled md2-selects show selected labels
          this.UnitTypeList = product.unit ? [{ id: product.unit, unit_type: product.unit_type_name ? product.unit_type_name : product.unit }] : [];
          this.hsncodelist = product.hsn_id ? [{ id: product.hsn_id, name: product.hsn_code }] : (product.hsnid ? [{ id: product.hsnid, name: product.hsn_code }] : []);
          this.typeList = product.product_type ? [{ name: product.product_type }] : [];
          this.typeList2 = product.product_type2_id ? [{ id: product.product_type2_id, type_name: product.product_type2_name ? product.product_type2_name : product.product_type2_id }] : [];
          this.productCategory = product.category ? [{ id: product.category, name: product.category_name ? product.category_name : product.category }] : [];
          this.productSubCategory = product.subcategory ? [{ id: product.subcategory, name: product.subcategory_name ? product.subcategory_name : product.subcategory }] : [];
          this.accountCodeList = product.account_id ? [{ id: product.account_id, name: product.account_name ? product.account_name : (product.account_code ? product.account_code : product.account_id) }] : (product.account_code ? [{ id: product.account_code, name: product.account_name ? product.account_name : product.account_code }] : []);
          this.qcList = product.qc_process ? [{ id: product.qc_process, name: product.qc_process }] : [];
          this.tdsList = product.tds_id ? [{ id: product.tds_id, section_name: product.section_name ? product.section_name : product.tds_id }] : [];
          const approvalName = product.approval_name || (product.approved_by_first_name || product.approved_by_last_name
            ? [product.approved_by_first_name, product.approved_by_last_name].filter(Boolean).join(' ').trim() : '');
          this.approvalList = approvalName ? [{ id: product.approval_id || approvalName, name: approvalName }] : [];

          this.commonVariableList.tableDetails = {
            id: 'productmaster',
            is_setup: true,
            setup: this.company_setup,
            data: { items: [product], is_no_tds_deduction: "1" }
          };
          this.commonVariableList.attachments = resp.attachments ? resp.attachments : (product && product.attachments ? product.attachments : []);

          // Build master-like savedFiles array for in-form attachment UI
          const atts: any[] = this.commonVariableList.attachments && this.commonVariableList.attachments.length ? this.commonVariableList.attachments : [];
          this.savedFiles = atts.map(a => {
            const filename = a.filename ? a.filename : (a.file_name ? a.file_name : (a.name ? a.name : ''));
            const display = a.display ? a.display : (a.attachment ? a.attachment : (a.url ? a.url : ''));
            const ext = this.webService.getFileExtension(display ? display : filename);
            return {
              filename: filename,
              display: display,
              iconclass: this.webService.getFileIcon(ext ? ext : ''),
            };
          });
        } else {
          this.toasterService.pop('error', 'Error', resp && resp.message ? resp.message : 'No data found');
        }
        this.commonVariableList.isProgressing = false;
      },
      error => {
        this.commonVariableList.isProgressing = false;
        this.toasterService.pop('error', 'Error', 'Something Went Wrong');
      }
    );
  }

  // Stubs used by master Product UI template (view-only)
  is_column_mandatory(key: string, is_child: boolean): boolean { return false; }
  is_column_disabled(key: string, is_child: boolean): boolean { return false; }
  is_Valid_Action(name: string): boolean { return false; }
  setUnitType(v: any) { }
  getProductNature(v: any) { }
  getSubcategory(v: any, idx: any) { }
  checkIsCapex(idx: any, key: any) { }
  getCategoryCodeOnChange(idx: any, v: any, key: any, mode: any) { }
  validateProductType(v: any, idx: any) { }
  selected(e: any) { }
  getImpactValue(v: any, idx: any) { }
  rcm(v: any) { }
  rcmndgst(v: any) { }
  BuyAccountInfo() { }
  SaleAccountInfo() { }
  salesProductChange(idx: any) { }
  isAlreadyDefaultUOM(idx: any): boolean { return false; }
  setBuyUOE(v: any, i: any) { }
  setSaleUOE(v: any, i: any) { }
  setDefaultUOE(v: any, i: any) { }
  addArray(idx: any) { }
  importUnitype(u: any) { }
  deleteArray(di: any, i: any) { }
  changeListener(e: any) { }
  removeImage(i: any) { }
  showToolTip(v: any) { }
  getData(v: any) { return ''; }
  showProductpup() { }
  checktaxrate(v: any, key: any) { }
  /** Display text for Product Master view-only popup (no md2-select); uses pre-filled lists from API */
  getProductMasterUnitDisplay(): string { return (this.UnitTypeList && this.UnitTypeList[0]) ? (this.UnitTypeList[0].unit_type || '') : ''; }
  getProductMasterCategoryDisplay(): string { return (this.productCategory && this.productCategory[0]) ? (this.productCategory[0].name || '') : ''; }
  getProductMasterSubCategoryDisplay(): string { return (this.productSubCategory && this.productSubCategory[0]) ? (this.productSubCategory[0].name || '') : ''; }
  getProductMasterHsnDisplay(): string { return (this.hsncodelist && this.hsncodelist[0]) ? (this.hsncodelist[0].name || '') : ''; }
  getProductMasterType2Display(): string { return (this.typeList2 && this.typeList2[0]) ? (this.typeList2[0].type_name || '') : ''; }
  getProductMasterTdsDisplay(): string { return (this.tdsList && this.tdsList[0]) ? (this.tdsList[0].section_name || '') : ''; }
  getProductMasterApprovalDisplay(): string {
    const p = this.productData && this.productData[0];
    if (p && p.approved_by_first_name) {
      const fn = String(p.approved_by_first_name).replace(/\s+/g, '').toUpperCase();
      return p.employee_code ? `${fn} (${String(p.employee_code).trim()})` : fn;
    }
    return (this.approvalList && this.approvalList[0]) ? (this.approvalList[0].name || '') : '';
  }
  getId(id: any, action: string, data: any) {
    this.sendAction.emit({
      "id": id,
      "action": action,
      "data": data,
    });
  }
  hideModal() {
    this.modalDetails.is_view = false;
    localStorage.setItem('dataList', '');
    document.getElementById('body').style.overflow = 'auto';
  }
  showPr(data) {

    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
    let payload: any = { "pr_no": data.pr_no }
    let api_url='pr/ajax_getsingleprdatabypr';
    let url:any='/'+window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
    let isdraft = data.is_draft
    if(isdraft=='1')
    {
      payload.is_draft=isdraft;
      api_url='/Pr/ajax_getsingledraftprdata'
    }
    else{
      api_url='pr/ajax_getsingleprdatabypr'
    }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod(api_url, data).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;
            response = data.response ? data.response : {};
            if (response.pr_items) {
              let sl_no: number = 1;
              for (let j of response.pr_items) {
                j.sl_no = sl_no;
                j.product_catalog_id = j.product_catalog_id ? j.product_catalog_id : j.product.product_catalog_id

                j.product_name = j.product.product_name;
                j.productcode = j.product.productcode;
                j.is_temp_prod = j.product.is_temp_prod ? j.product.is_temp_prod : '0';
                j.product_name = j.product_name + (j.is_temp_prod=='1' ? '' : "(" + j.productcode + ")");
                j.product_type = j.product.product_type ? j.product.product_type : '';
                sl_no++;
              }
            }
            if (response.approvals) {
              for (let i of response.approvals) {
                i.approval_first_name = i.user.first_name
                i.approval_last_name = i.user.last_name
                i.employee_code = i.user.employee_code;

              }
            }
            if(Array.isArray(response.need_info))
            {
              response.need_info={"user":{}};
            }
            response.is_need_info=Array.isArray(response.info_history)?response.info_history.length>0?true:false:false;
            response.is_need_info= response.is_need_info;
            response.info_history= response.info_history?response.info_history:[]

            if(response.info_history)
            {
              for(let i of response.info_history)
              {

                i.approval_first_name=i.requested_by_first_name?i.requested_by_first_name:''
                i.approval_last_name=i.requested_by_last_name?i.requested_by_last_name:'';
                i.employee_code=i.requested_by_employee_code?i.requested_by_employee_code:'';

                i.info_first_name=i.requestby.first_name?i.requestby.first_name:'';
                i.info_last_name=i.requestby.last_name?i.requestby.last_name:'';
                i.info_employee_code=i.requestby.employee_code?i.requestby.employee_code:'';

              }
            }
            response.requested_by = response.user.first_name + " " + response.user.last_name + "(" + response.user.employee_code + ")"

            response.location = response.location.location ? response.location.location : ''
            response = data.response ? data.response : {};

            response.dimension_type_name = response.dimension_type_name ? response.dimension_type_name : ''
            response.boq_dimension_type_name = response.boq_dimension_type_name ? response.boq_dimension_type_name : ''


            response.dimension_name = response.dimension_name ? response.dimension_name : ''
            if (response.dimension_type_name != '') {
              response.dimension_name = response.dimension_name + "(" + response.dimension_type_name + ")";
            }

            response.boq = response.boq ? response.boq : '';
            response.is_boq = response.is_boq == '1' ? true : false;
            response.boq_quantity = response.boq_quantity ? response.boq_quantity : '';
            if (response.boq_dimension_type_name != '') {
              response.boq_name = response.boq_name + "(" + response.boq_dimension_type_name + ")";
            }
           response.customer_detail='';
            if(response.customer_first_name!='' &&response.customer_first_name!=undefined)
            {
            response.customer_detail=response.customer_first_name+" "+response.customer_last_name+" ("+response.customer_code+")";
            }
            if(response.customer_address!='' && response.customer_address!=null)
            {
             response.customer_detail=response.customer_address;
            }
            response.project_name=response.project_name?response.project_name:'';
            response.project_code=response.project_code?response.project_code:'';
            response.project_detail='';
             if(response.project_name!='' &&response.project_name!=undefined)
             {
              response.project_detail=response.project_name+" ("+response.project_code+")";
             }
            response.task_name=response.task_name?response.task_name:'';
            response.task_code=response.task_code?response.task_code:'';
            response.task_detail='';
             if(response.task_name!='' &&response.task_name!=undefined)
             {
              response.task_detail=response.task_name+" ("+response.task_code+")";
             }

            response.sales_order_no = response.sales_order_no ? response.sales_order_no : '';
            response.pr_approvals = []
            response.pr_approvals = response.approvals ? response.approvals : [];
            // response.pr_attachments = [];
            // response.pr_attachments = response.attachments ? response.attachments : []
            response.attachment = [];
            response.attachment = this.webService.makeAttachment(response.attachments) ? this.webService.makeAttachment(response.attachments) : []
            response.ship_dept_name=response.ship_dept_name?response.ship_dept_name:'';
            response.ship_dept_code=response.ship_dept_code?response.ship_dept_code:'';
            response.ship_primary_loc_name=response.ship_primary_loc_name?response.ship_primary_loc_name:'';
            response.ship_primary_loc_code=response.ship_primary_loc_code?response.ship_primary_loc_code:'';
            response.ship_lob_name=response.ship_lob_name?response.ship_lob_name:'';
            response.ship_lob_code=response.ship_lob_code?response.ship_lob_code:'';

          }
          else {
            this.toasterService.pop('error', "Error", data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          }
          response.id = "prreport";
          response.data = response;

          this.makeFinalData(response);
        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }
  showIr(data) {

    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
    let payload: any = { "ir_no": data.ir_no }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod('Ir/ajax_getsingleprdatabyir', data).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;
            response = data.response ? data.response : {};
            this.irFields.prepareIrReportDataForDisplay(response);
            if (response.approvals) {
              for (let i of response.approvals) {
                i.approval_first_name = i.user.first_name
                i.approval_last_name = i.user.last_name
                i.employee_code = i.user.employee_code;

              }
            }

            response.requested_by = response.user.first_name + " " + response.user.last_name + "(" + response.user.employee_code + ")"

            response.location = response.location.location ? response.location.location : ''
            response = data.response ? data.response : {};

            response.dimension_type_name = response.dimension_type_name ? response.dimension_type_name : ''
            response.boq_dimension_type_name = response.boq_dimension_type_name ? response.boq_dimension_type_name : ''


            response.dimension_name = response.dimension_name ? response.dimension_name : ''
            if (response.dimension_type_name != '') {
              response.dimension_name = response.dimension_name + "(" + response.dimension_type_name + ")";
            }

            response.boq = response.boq ? response.boq : '';
            response.is_boq = response.is_boq == '1' ? true : false;
            response.boq_quantity = response.boq_quantity ? response.boq_quantity : '';
            if (response.boq_dimension_type_name != '') {
              response.boq_name = response.boq_name + "(" + response.boq_dimension_type_name + ")";
            }
            response.pr_approvals = []
            response.pr_approvals = response.approvals ? response.approvals : [];
            response.pr_attachments = [];
            response.pr_attachments = response.attachments ? response.attachments : []
            response.attachment = [];
            response.attachment = this.webService.makeAttachment(response.attachments) ? this.webService.makeAttachment(response.attachments) : []

          }
          else {
            this.toasterService.pop('error', "Error", data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          }
          response.id = "irreport";
          response.data = response;
          this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/raiseir');

          this.makeFinalData(response);
        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }
  showIRHistory(data) {

    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
    let payload: any = { "ir_id": data.ir_id }
    this.commonVariableList.isProgressing = true;
    this.commonVariableList.historyList=[];
    this.webService.commonPostMethod('Ir/ir_history', data).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;
            let temp:any=[];
            temp = data.response ? data.response :[];
            if(temp)
            {
              for(let m of temp)
              {
            this.irFields.prepareIrReportDataForDisplay(m);
            if (m.approvals) {
              for (let i of m.approvals) {
                i.approval_first_name = i.user.first_name
                i.approval_last_name = i.user.last_name
                i.employee_code = i.user.employee_code;

              }
            }

            m.requested_by = m.user.first_name + " " + m.user.last_name + "(" + m.user.employee_code + ")"

            m.location = m.location.location ? m.location.location : ''
            m = m ? m : {};

            m.dimension_type_name = m.dimension_type_name ? m.dimension_type_name : ''
            m.boq_dimension_type_name = m.boq_dimension_type_name ? m.boq_dimension_type_name : ''


            m.dimension_name = m.dimension_name ? m.dimension_name : ''
            if (m.dimension_type_name != '') {
              m.dimension_name = m.dimension_name + "(" + m.dimension_type_name + ")";
            }

            m.boq = m.boq ? m.boq : '';
            m.is_boq = m.is_boq == '1' ? true : false;
            m.boq_quantity = m.boq_quantity ? m.boq_quantity : '';
            if (m.boq_dimension_type_name != '') {
              m.boq_name = m.boq_name + "(" + m.boq_dimension_type_name + ")";
            }
            m.pr_approvals = []
            m.pr_approvals = m.approvals ? m.approvals : [];
            m.pr_attachments = [];
            m.pr_attachments = m.attachments ? m.attachments : []
            m.attachment = [];
            m.attachment = this.webService.makeAttachment(m.attachments) ? this.webService.makeAttachment(m.attachments) : []
            m.id = "ir_history_report";
            m.data = m;
            this.commonVariableList.dataList.push(m)
      m.beforedivList = m.beforedivList ? m.beforedivList : []
      m.afterdivList = m.afterdivList ? m.afterdivList : []


    m.afterDivDetails = {};
    m.afterDivDetails = m;
    m.beforeDivDetails = {};
    m.beforeDivDetails = m;
    m.tableDetails = {};
    m.tableDetails = m;
    m.approvalDetails = {};
    m.approvalDetails = m;
    m.allocableCostDetails = {};
    m.allocableCostDetails = m;
    m.allocableCostDetails.lines = m.allocable_cost_items || [];
    m.allocableCostDetails.viewContext = (m.tableDetails && m.tableDetails.data) ? m.tableDetails.data : (m || {});
    m.allocableCostDetails.caption = 'Additional Cost Line items (Not Part of Vendor PO)';
    m.allocableCostDetails.is_setup = true;
    m.allocableCostDetails.setup = this.comanySetup.getData();
    m.allocableCostDetails.is_view = this.isAllocableCostTableVisibleForHistory(m);
    m.attachments = [];
    m.attachments = m.attachment ? m.attachment : [];
            this.commonVariableList.historyList.push(m);
          }
        }
          }
          else {
            this.toasterService.pop('error', "Error", data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
            response.id = "ir_history_report";
            response.data = response;
            this.commonVariableList.historyList.push(response);
          }
          // response.id = "ir_history_report";
          // response.data = response;
          this.modalDetails.name="IR History"
          this.modalDetails.is_view = true;
          this.commonVariableList.isProgressing = false;
          // this.makeFinalData(response);

        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }
  showPo(data) {
    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [], "contractualPoAttachments": [] };

    let payload: any = { "po_no": data.po_no ,'is_modified':data.is_modified?data.is_modified:'0',
  type:'my_po'
  }
  let api_url='po/ajax_get_single_podetails';
  let url:any='/'+window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
  if(data.is_draft=='1')
  {
    payload.is_draft=data.is_draft;
    api_url='po/get_single_draft_po'
  }
  if(url!='/my-orders')
  {
  delete payload['type'];

  }
  console.log(url);
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod(api_url, data).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;

            if (data.response.items) {
              for (let j of data.response.items) {



                j.amend_po_status=j.is_amend=='1'?'Closed':'';
                j.amend_po_qty=j.is_amend=='1'?j.close_po_qty:'';
                j.amend_date=j.amend_date?j.amend_date:'';
                j.amend_added_by=j.amend_added_by?j.amend_added_by:'';

                // Prefer showing HSN with IGST details (if available), else show plain HSN code.
                // Generic table column mapping uses "hsn_code", so normalize it for display.
                let hsnCodeIgst: string = (j.hsn_code_igst ? String(j.hsn_code_igst) : '').trim();
                let hsnCode: string = (j.hsn_code ? String(j.hsn_code) : '').trim();
                j.hsn_code = hsnCodeIgst ? hsnCodeIgst : hsnCode;

                j.product_name = j.product_name + " (" + j.productcode + ")";
                j.ship_location_nickname_9_digit = data.response.ship_to_location_name.location_nickname_9_digit;
                j.ship_location_code_9_digit = data.response.ship_to_location_name.location_code_9_digit;

                j.ship_to_location = j.ship_location_nickname_9_digit ? j.ship_location_nickname_9_digit : j.ship_to_location;
                j.ship_to_location = j.ship_location_nickname_9_digit + "(" + j.ship_location_code_9_digit + ")";

                j.total_duration = j.total_duration ? j.total_duration : '';
                j.is_logistic = j.is_logistic == '1' ? true : false;

                j.hsn_cess=j.hsn_cess?j.hsn_cess:''
                j.hsn_other_tax=j.hsn_other_tax?j.hsn_other_tax:''
                j.hsn_ugst=j.hsn_ugst?j.hsn_ugst:''
                j.hsn_cgst=j.hsn_cgst?j.hsn_cgst:''
                j.hsn_sgst=j.hsn_sgst?j.hsn_sgst:''
                j.hsn_igst=j.hsn_igst?j.hsn_igst:''
                j.info_employee_code = j.info_employee_code ? j.info_employee_code :''
                j.info_first_name = j.info_first_name ? j.info_first_name :''
                j.info_last_name = j.info_last_name ? j.info_last_name :''
                j.is_raiser = j.is_raiser ? j.is_raiser :''
                if(this.company_setup.gst_fields_not_shown_when_value_is_zero == '1'){
                  j.CgstVisible = data.response.items ? data.response.items.some((d)=>{return d.cgst>0}): false;
                  j.SgstVisible = data.response.items ? data.response.items.some((d)=>{return d.sgst>0}): false;
                  j.IgstVisible = data.response.items ? data.response.items.some((d)=>{return d.igst>0}): false;
                  j.UgstVisible = data.response.items ? data.response.items.some((d)=>{return d.ugst>0}): false;
                  j.CessVisible = data.response.items ? data.response.items.some((d)=>{return d.cess>0}): false;
                  j.OthertaxVisible = data.response.items ? data.response.items.some((d)=>{return d.other_tax>0}): false;
                  j.DiscountAmount = data.response.items ?  data.response.items.some((d)=>{return d.discount_amount>0}): false;
                } else {
                  j.CgstVisible = true;
                  j.SgstVisible = true;
                  j.IgstVisible = true;
                  j.UgstVisible = true;
                  j.CessVisible = true;
                  j.OthertaxVisible = true;
                  j.DiscountAmount = true;
                }
              }
            }

            response = data.response ? data.response : {};
            response.bill_location_nickname_9_digit = data.response.bill_to_location_name.location_nickname_9_digit;
            response.bill_location_code_9_digit = data.response.bill_to_location_name.location_code_9_digit;
            response.is_boq = data.response.is_boq == '1' ? true : false;
            response.is_different_document_currency = data.response.is_different_document_currency == '1' ? true : false;
            // Get document_currency_code from multiple possible sources
            response.document_currency_code = data.response.document_currency_code || data.response.currency_code || (data.response.currency && data.response.currency.code) || '';

            response.is_draft = api_url=='po/get_single_draft_po'?'1':'0'
            response.po_items = [];
            response.po_items = response.items ? response.items : []
            response.po_approvals = []
            response.po_approvals = response.approvals ? response.approvals : [];
            response.po_attachments = [];
            response.po_attachments = response.attachments ? response.attachments : []
            response.attachment = [];
            response.po_additional_attachment =[]
            response.attachment = this.webService.makeAttachment(response.attachments) ? this.webService.makeAttachment(response.attachments) : [];
            response.po_additional_attachment = this.webService.makeAttachment(response.po_additional_attachments) ? this.webService.makeAttachment(response.po_additional_attachments) : [];
            response.po_additional_attachments_title= response.po_additional_attachments ? 'PO Additional Attachment':''

            response.contractualPoAttachments = this.webService.makeAttachment(response.contractualPoAttachments) ? this.webService.makeAttachment(response.contractualPoAttachments) : [];
            response.requested_by_employee_code = response.requested_by_employeecode ? response.requested_by_employeecode : '';

            // Handle allocable cost items
            this.commonVariableList.is_allocable_cost = data.response.is_allocable_cost == "1" ? true : false;
            this.commonVariableList.allocableCostLines = data.response.allocable_cost_items ? data.response.allocable_cost_items : [];
            // Store document_currency_code for easy access in template
            this.commonVariableList.document_currency_code = response.document_currency_code || '';
            if (this.commonVariableList.allocableCostLines && this.commonVariableList.allocableCostLines.length > 0) {
              // Sort allocableCostLines to maintain order
              this.commonVariableList.allocableCostLines.sort((a, b) => {
                const idA = a.allocable_cost_item_id || a.id;
                const idB = b.allocable_cost_item_id || b.id;
                if (idA && idB) {
                  return idA - idB;
                }
                return 0; // Preserve original order if no ID is present
              });
              for (let costLine of this.commonVariableList.allocableCostLines) {
                costLine.planned_amount_in_po_currency = costLine.planned_amount_in_po_currency || '0.00';
                costLine.planned_amount_in_base_currency = costLine.planned_amount_in_base_currency || '0.00';
              }
            }

            if(this.modalDetails.data && this.modalDetails.data.type == 'fulfilled_po'){
              response.fulfilled_po_upload_invoice = [];
              response.fulfilled_po_upload_invoice = this.webService.makeAttachment(response.fulfilled_po_upload_file) ? this.webService.makeAttachment(response.fulfilled_po_upload_file) : [];
              response.fulfilled_po_upload_invoice_title = response.fulfilled_po_upload_file && response.fulfilled_po_upload_file.length > 0 ? 'Upload Invoice' : '';
              
              response.fulfilled_po_vendor_attachment = [];
              response.fulfilled_po_vendor_attachment = this.webService.makeAttachment(response.fulfilled_po_upload_invoice_attachment) ? this.webService.makeAttachment(response.fulfilled_po_upload_invoice_attachment) : [];
              response.fulfilled_po_vendor_attachment_title = response.fulfilled_po_upload_invoice_attachment && response.fulfilled_po_upload_invoice_attachment.length > 0 ? 'Vendor Attachment' : '';
            }
          }
          else {
            this.toasterService.pop('error', "Error", data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [], "contractualPoAttachments": [] };
          }

          response.id = "poreport";
          response.data = response;
          if(this.modalDetails.data && this.modalDetails.data.type == 'fulfilled_po'){
            this.modalDetails.name = this.modalDetails.name ? this.modalDetails.name : 'Vendor Fulfilled PO';
          } else {
            this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/raise-po');
          }
          this.makeFinalData(response);



        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [], "contractualPoAttachments": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }
  showIrn(data) {
    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
    const requestData: any = data ? data : {};
    

    let payload: any = { "irn_cs_id": data.cs_id, "merge_grn_irn": this.company_setup.merge_grn_irn ? this.company_setup.merge_grn_irn : '0' }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod('irn/ajax_get_single_irndetails', payload).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;

            if (data.response.irn_items) {
              for (let j of data.response.irn_items) {
                // TEMP: remove after UI check
                // Prefer HSN with IGST details when present, else plain HSN (same as PO / invoice popup).
                let irnHsnCodeIgst: string = (j.hsn_code_igst ? String(j.hsn_code_igst) : '').trim();
                let irnHsnCode: string = (j.hsn_code ? String(j.hsn_code) : '').trim();
                j.hsn_code = irnHsnCodeIgst ? irnHsnCodeIgst : irnHsnCode;
                j.product_name = j.product_name + " (" + j.productcode + ")";
                j.is_damaged = j.is_damaged == '1' ? true : false;
                j.merge_barcode=j.merge_barcode?j.merge_barcode:'0';
                j.merge_barcode=j.merge_barcode=='1'?true:false;
                j.total_grn_value_po_price = j.po_total_price ? j.po_total_price : '';

              }
            }
            if(data.response.irn_other_info)
            {
              for(let i of data.response.irn_other_info)
              {
                i.first_name=i.first_name?i.first_name:''
                i.last_name=i.last_name?i.last_name:''
                i.adhoc_employee_id=i.first_name+" "+i.last_name;
                if(i.employee_code!=undefined && i.employee_code!=null)
                {
                  i.adhoc_employee_id=i.adhoc_employee_id+" ("+i.employee_code+")";
                }
              }
            }
            response = data.response ? data.response : {};
            response.acceptedList = response.acceptedList ? response.acceptedList : [];
            response.rejectedList = response.rejectedList ? response.rejectedList : [];
            response.hide_free_qty_if_zero = requestData.hide_free_qty_if_zero ? requestData.hide_free_qty_if_zero : '0';

            response.bill_to_location = response.bill_to_location_name
            response.ship_to_location = response.ship_to_location_name

            response.requested_by_first_name = response.added_by_first_name;
            response.requested_by_last_name = response.added_by_last_name;
            response.requested_by_employee_code = response.added_by_employee_code;
            response.approval_status=response.approval_status;
            if(response.approvals)
            {
              for(let i of response.approvals)
              {
                i.approval_first_name=i.approval_first_name?i.approval_first_name:i.first_name;
                i.approval_last_name=i.approval_last_name?i.approval_last_name:i.last_name
              }
            }
            response.approvals = response.approvals ? response.approvals : [];

            response.attachment = [];
            response.attachment = this.webService.makeAttachment(response.attachments) ? this.webService.makeAttachment(response.attachments) : []

            response.extra_attachment_1 = [];
            response.extra_attachment_1 = this.webService.makeAttachment(response.invoice_attachments) ? this.webService.makeAttachment(response.invoice_attachments) : []
            response.extra_attachment_qc = [];
            response.extra_attachment_qc = this.webService.makeAttachment(response.irn_attachments) ? this.webService.makeAttachment(response.irn_attachments) : []
            response.extra_attachment_1_title='Invoice Files'
            response.attachment_title='IRN Files'
            response.attachment_title_qc='IRN Files'

            response.multi_attachments = response.multi_attachments ? response.multi_attachments : [];
            response.invoice_attachments = response.invoice_attachments ? response.invoice_attachments : [];
            response.attachments = this.webService.makeAttachment(response.invoice_attachments) ? this.webService.makeAttachment(response.invoice_attachments) : []



            for(let i of response.multi_attachments) {
              i.attachments = this.webService.makeAttachment(i.attachments) ? this.webService.makeAttachment(i.attachments) : []
            }
          }
          else {
            this.toasterService.pop('error', "Error", data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          }
          response.id = "irnreport";
          response.data = response;
          // this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/new-irn');
          this.modalDetails.name = this.irn_to_grn +' '+'Data';

          this.makeFinalData(response);
        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }
  showGrn(data) {

    this.commonVariableList.dataList = [];
    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
    const requestData: any = data ? data : {};

    // let payload: any = { "grn_cs_id": data.cs_id ? data.cs_id : '' }
    //chanukya chainged according to saurabh req
    let Id: any = "";
    data.has_approved_once=data.has_approved_once?data.has_approved_once:''
    if (data.cs_id) {
      Id = data.cs_id
    }
    if (data.cs_id.cs_id) {
      Id = data.cs_id.cs_id
    }
    let url:any='';
    if(data.is_summary=='1')
    {
      url="Grn/ajax_get_grn_detailsbyid";
    }
    else
    {
url="Grn/ajax_get_grn_byid";
    }

    let payload: any = {
      // "grn_cs_id":data.cs_id.cs_id,
      "grn_cs_id": Id,
      "grn_id": data.grn_id ? data.grn_id : '',
      "company_id": this._localStorageService.getEmpCompanyId() == undefined ? '0' : this._localStorageService.getEmpCompanyId(),
      "merge_grn_irn": this.company_setup.merge_grn_irn ? this.company_setup.merge_grn_irn : '0',
      // "is_unapproved_grn" : this.company_setup.has_multi_grn_approval ? this.company_setup.has_multi_grn_approval : "0",
      "has_approved_once":data.has_approved_once?data.has_approved_once:''
    }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod(url, payload).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;

            if (data.response.grn_items) {
              for (let j of data.response.grn_items) {
                let allocated_arr:any=[];
                let allocated_rack_code='';
                j.merge_barcode=j.merge_barcode?j.merge_barcode:'0';
                j.product_description=j.product_description?j.product_description:'';

                j.merge_barcode=j.merge_barcode=='1'?true:false;
                // TEMP: remove after UI check
                // Prefer HSN with IGST details when present, else plain HSN (same as PO / invoice popup).
                let grnHsnCodeIgst: string = (j.hsn_code_igst ? String(j.hsn_code_igst) : '').trim();
                let grnHsnCode: string = (j.hsn_code ? String(j.hsn_code) : '').trim();
                j.hsn_code = grnHsnCodeIgst ? grnHsnCodeIgst : grnHsnCode;
                j.product_name = j.product_name + " (" + j.productcode + ")";
                j.is_closed = j.is_closed == '1' ? true : false;
                j.send_damage_mail = j.send_damage_mail == '1' ? true : false;
                j.merge_barcode=j.merge_barcode?j.merge_barcode:'0';
                j.merge_barcode=j.merge_barcode=='1'?true:false;
                if(j.allocated_rack && j.allocated_rack.length>0)
                {
                  for(let m of j.allocated_rack)
                  {
                   m.allocated_rack_code = m.allocated_rack_no + " (" + m.allocated_qty + ")";
                   allocated_arr.push(m.allocated_rack_code)
                  }
                  allocated_rack_code=allocated_arr.join(',');
                }
                j.allocated_rack_code=allocated_rack_code?allocated_rack_code:''
                j.total_grn_value_po_price = j.po_total_price ? j.po_total_price : '';
              }
            }
            if(data.response.grn_other_info)
            {
              for(let i of data.response.grn_other_info)
              {
                i.first_name=i.first_name?i.first_name:''
                i.last_name=i.last_name?i.last_name:''
                i.adhoc_employee_id=i.first_name+" "+i.last_name;
                if(i.employee_code!=undefined && i.employee_code!=null)
                {
                  i.adhoc_employee_id=i.adhoc_employee_id+" ("+i.employee_code+")";
                }
              }
            }
            response = data.response ? data.response : {};
            response.hide_free_qty_if_zero = requestData.hide_free_qty_if_zero ? requestData.hide_free_qty_if_zero : '0';
            response.bill_location_nickname_9_digit = response.bill_name?response.bill_name:response.bill_location_nickname_9_digit;
            response.ship_location_nickname_9_digit = response.ship_name;

            

            response.acceptedList = response.acceptedList ? response.acceptedList : [];
            response.rejectedList = response.rejectedList ? response.rejectedList : [];
            response.employee_code = response.added_by_employee_code ? response.added_by_employee_code : ''
            response.requested_by = response.added_by_first_name + " " + response.added_by_last_name + " (" + response.employee_code + ")"
            response.approvals = response.approvals ? response.approvals : [];

            response.attachment = [];
            response.attachment = this.webService.makeAttachment(response.attachments) ? this.webService.makeAttachment(response.attachments) : []

            response.extra_attachment_1 = [];
            response.extra_attachment_1 = this.webService.makeAttachment(response.invoice_attachments) ? this.webService.makeAttachment(response.invoice_attachments) : []

            response.extra_attachment_qc = [];
            response.extra_attachment_qc = this.webService.makeAttachment(response.irn_attachments) ? this.webService.makeAttachment(response.irn_attachments) : []

            response.extra_attachment_1_title='Invoice Files'
            response.attachment_title='QC Files'
            response.attachment_title_qc='IRN Files'
                          response.multi_attachments = response.multi_attachments ? response.multi_attachments : [];
            for(let i of response.multi_attachments) {
              i.attachments = this.webService.makeAttachment(i.attachments) ? this.webService.makeAttachment(i.attachments) : []
            }
          }
          else {
            this.toasterService.pop('error', "Error", data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          }
          response.id = "grnreport";
          response.data = response;
          this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/add-grn');
           this.modalDetails.name = this.grn_to_qc + ' ' + 'Data';

          this.makeFinalData(response);
        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }
  showInvoicePayment(data) {
    this.commonVariableList.dataList = [];
    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };

    let payload: any = { "invoice_payment_id": data.cs_id, "id_type": data.id_type ? data.id_type : 'id', "merge_grn_irn": this.company_setup.merge_grn_irn ? this.company_setup.merge_grn_irn : '0' }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod('Invoice_payment/ajax_get_invoice_payment_details_byid', payload).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;
            if (data.response.length > 0) {
              if (data.response[0].payment_details) {
                for (let d of data.response[0].payment_details) {
                  d.vendor = d.vendor_first_name + " " + d.vendor_last_name + "(" + d.vendor_code + ")";
                }
              }
              response = data.response[0] ? data.response[0] : {};
              response.requested_by = response.added_by_first_name + " " + response.added_by_last_name + " (" + response.employee_code + ")"
              response.approvals = response.payment_approvals ? response.payment_approvals : [];

              response.attachment = [];
              response.final_approval_status = response.final_approval_status ? response.final_approval_status : '0';

              // response.attachment = this.webService.makeAttachment(response.attachments)
            }
            else {
              response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };

            }
          }
          else {
            this.toasterService.pop('error', 'Error', data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          }
          response.id = "invoicepaymentreport";
          response.data = response;
          this.makeFinalData(response);
        },
        error => {
          this.toasterService.pop('error', 'Error', 'Something Went Wrong');
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }
  showAdhocPayment(data) {
    this.commonVariableList.dataList = [];
    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };

    let payload: any = { "dp_id": data.id }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod('po/getAdhocAdvancePaymentById', payload).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;
            // if (data.response.length > 0) {
              response = data.response ? data.response : {};
              response.requested_by = response.added_by_first_name + " " + response.added_by_last_name + " (" + response.employee_code + ")"
              response.approvals = response.adhoc_advance_payment_approvals ? response.adhoc_advance_payment_approvals : [];
             if(response.approvals)
             {
               for(let i of response.approvals)
               {
                 i.employee_code=i.employee_code?i.employee_code:i.approval_employee_code;
               }
             }
              response.attachment = [];
              response.attachment = this.webService.makeAttachment(response.adhoc_advance_payment_attachments)
            // }
            // else {
            //   response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };

            // }
          }
          else {
            this.toasterService.pop('error', 'Error', data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          }
          response.id = "adhocpaymentreport";
          response.data = response;
          this.makeFinalData(response);
        },
        error => {
          this.toasterService.pop('error', 'Error', 'Something Went Wrong');
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }
  showAndroidInvoice(d)
  {
    this.commonVariableList.dataList = [];
    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
    let is_this_invoice_no: any = '';
    let url: any = '';

      is_this_invoice_no = d.is_this_invoice_no ? d.is_this_invoice_no : '1';
      url = 'Invoice_drafts/ajax_get_invoice_for_android_by_id';

    let payload: any = {
      "invoice_id": d.id, 'is_this_invoice_no': is_this_invoice_no
    }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod(url, payload).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;



            response = data.response[0] ? data.response[0] : {};
            if(response.approvals)
            {
              for(let i of response.approvals)
              {
                i.employee_code=i.approval_code?i.approval_code:'';
              }
            }

            response.vendor_name=response.vendor_first_name+" "+response.vendor_last_name+ "("+response.vendor_code+")";
            response.ship_name=response.ship_to_location_name+" "+"("+response.ship_to_location_code_9_digit+")";
            response.invoice_date = this.webService.formatDate(response.invoice_date, "yy-mm-dd", "-", false) ? response.invoice_date : "";
            response.requested_by=response.added_by_first_name+" "+response.added_by_last_name+" "+"("+response.added_by_employee_code+")";
            response.invoice_no = response.invoice_no ? response.invoice_no : '';
            response.invoice_amount = response.invoice_amount ? response.invoice_amount : '';

            // response.vendor_gst_no = response.vendor_gst_number ? response.vendor_gst_number : '';
            console.log(response.vendor_gst_no)
            response.requested_by = response.added_by_first_name + " " + response.added_by_last_name + " (" + response.employee_code + ")"
            response.invoice_approvals = response.approvals ? response.approvals : [];
            // response.attachment = [];

            response.attachment = this.webService.makeAttachment(response.attachment)
          }
          else {
            this.toasterService.pop('error', "Error", data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          }
          response.id = "invoice_android_report";
          response.data = response;
          // console.log(response);
          this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/generate-invoice-android');

          this.makeFinalData(response);
        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }

  showInvoice(d) {
    this.commonVariableList.dataList = [];
    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [],"extra_attachment_2":[] };
    let is_this_invoice_no: any = '';
    let url: any = '';
    d.is_vendor_invoice=d.is_vendor_invoice?d.is_vendor_invoice:'0';
    d.hideApproval=d.hideApproval?d.hideApproval:'0';
    if (d.is_this_invoice_no == '' || d.is_this_invoice_no == undefined) {
      is_this_invoice_no = '0'
      url = 'Invoices/ajax_get_invoice_details_byid_v2';
    }
    else if (d.is_this_invoice_no == '1') {
      is_this_invoice_no = d.is_this_invoice_no ? d.is_this_invoice_no : '1';
      url = 'Invoices/ajax_get_invoice_details_byvendorinvoicenumber';
    }
    else if (d.is_this_invoice_no == '2') {
      is_this_invoice_no = d.is_this_invoice_no ? d.is_this_invoice_no : '1';
      url = 'Invoices/ajax_get_invoice_details_byvendorinvoicenumber';
    }

    if(d.is_vendor_invoice=='1')
    {
      is_this_invoice_no = '0'
      url = 'Invoices/vendor_invoice_details_byid';
    }
    d.show_multi_inv = d.show_multi_inv ? d.show_multi_inv : '0';
    let payload: any = {
      "invoice_id": d.id, "p_type": d.p_type, 'is_this_invoice_no': is_this_invoice_no
      , "merge_grn_irn": this.company_setup.merge_grn_irn ? this.company_setup.merge_grn_irn : '0',
      is_draft:d.is_draft?d.is_draft:'0',
      "show_multi_inv": d.show_multi_inv,
    }
    // console.log('hey');
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod(url, payload).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;

            if (data.response.invoice_items) {
              for (let j of data.response.invoice_items) {
                j.unit_type_name = j.unit_type_name ? j.unit_type_name : j.unit_type
                j.subcategory_name = j.subcategory_name ? j.subcategory_name : j.sub_category_name;
                j.account_name = j.account_name ? j.account_name : '';
                j.account_code = j.account_code ? j.account_code : '';
                j.account_name = j.account_name + "(" + j.account_code + ")";
                j.location = data.response.ship_location_nickname_9_digit + "(" + data.response.ship_location_code_9_digit + ")"
                j.ship_to_location_gst_no=j.ship_to_location_gst_no?j.ship_to_location_gst_no:''
                if(j.ship_to_location_gst_no!=null&&j.ship_to_location_gst_no!='')
                {
                  if(this.country_data.country_id=='101')
                  {
                  j.location=j.location+"( GST - "+j.ship_to_location_gst_no+")";
                  j.ship_location=j.ship_location+"( GST - "+j.ship_to_location_gst_no+")";
                  }
                  else
                  {
                    j.location=j.location
                  j.ship_location=j.ship_location
                  }
                }
                if (data.response.dimension_name != undefined && data.response.dimension_name != '' && data.response.dimension_name != null) {
                  j.location = j.location + "( Dimension -" + data.response.dimension_name + " )"
                }
                j.location=j.ship_location?j.ship_location:j.location;
                // TEMP: remove after UI check
                // Prefer HSN with IGST details when present (same as PO details popup).
                let invHsnCodeIgst: string = (j.hsn_code_igst ? String(j.hsn_code_igst) : '').trim();
                let invHsnCode: string = (j.hsn_code ? String(j.hsn_code) : '').trim();
                j.hsn_code = invHsnCodeIgst ? invHsnCodeIgst : invHsnCode;
                j.product_name = j.product_name + " (" + j.productcode + ")";
                j.product_description = j.product_description ? j.product_description : '';
                j.description = j.description ? j.description : '';
                j.product_description = j.product_description=="" ? j.description : j.product_description;
              }

            }
            response = data.response ? data.response : {};
            response.advance_amount=response.advance_amount?response.advance_amount:'';
            response.show_multi_inv = d.show_multi_inv;
            
            // Map mailed_irn_no and mailed_eway_bill_no to irn_no and eway_bill_number for UI display
            response.irn_no = response.mailed_irn_no ? response.mailed_irn_no :  '';
            response.eway_bill_number = response.mailed_eway_bill_no ? response.mailed_eway_bill_no :  '';
            
            
            // Extract irn_no and eway_bill_number from scanned_invoice_meta or ocr_suggestions
            try {
              if (response.scanned_invoice_meta) {
                let scannedMeta;
                if (typeof response.scanned_invoice_meta === 'string') {
                  scannedMeta = JSON.parse(response.scanned_invoice_meta);
                } else {
                  scannedMeta = response.scanned_invoice_meta;
                }
                if (scannedMeta && scannedMeta.field_data) {
                  if (scannedMeta.field_data.irn_no && scannedMeta.field_data.irn_no.value) {
                    response.irn_no = scannedMeta.field_data.irn_no.value;
                  }
                  if (scannedMeta.field_data.eway_bill_number && scannedMeta.field_data.eway_bill_number.value) {
                    response.eway_bill_number = scannedMeta.field_data.eway_bill_number.value;
                  }
                }
              }
              // Also check ocr_suggestions as fallback
              if ((!response.irn_no || !response.eway_bill_number) && response.ocr_suggestions) {
                let ocrSuggestions;
                if (typeof response.ocr_suggestions === 'string') {
                  ocrSuggestions = JSON.parse(response.ocr_suggestions);
                } else {
                  ocrSuggestions = response.ocr_suggestions;
                }
                if (ocrSuggestions) {
                  if (!response.irn_no && ocrSuggestions.irn_no) {
                    response.irn_no = typeof ocrSuggestions.irn_no === 'object' && ocrSuggestions.irn_no.value 
                      ? ocrSuggestions.irn_no.value 
                      : ocrSuggestions.irn_no;
                  }
                  if (!response.eway_bill_number && ocrSuggestions.eway_bill_number) {
                    response.eway_bill_number = typeof ocrSuggestions.eway_bill_number === 'object' && ocrSuggestions.eway_bill_number.value 
                      ? ocrSuggestions.eway_bill_number.value 
                      : ocrSuggestions.eway_bill_number;
                  }
                }
              }
              // Ensure values are set (even if empty string)
              if (response.irn_no === undefined || response.irn_no === null) {
                response.irn_no = '';
              }
              if (response.eway_bill_number === undefined || response.eway_bill_number === null) {
                response.eway_bill_number = '';
              }
            } catch (e) {
              console.error('Error parsing scanned_invoice_meta or ocr_suggestions:', e);
              // If parsing fails, ensure values are set
              if (response.irn_no === undefined || response.irn_no === null) {
                response.irn_no = '';
              }
              if (response.eway_bill_number === undefined || response.eway_bill_number === null) {
                response.eway_bill_number = '';
              }
            }
            
            response.common_ship_location=response.ship_location_nickname_9_digit
            if(response.ship_location_code_9_digit!=''&&response.ship_location_code_9_digit!=undefined&&response.ship_location_code_9_digit!=null)
            {
              response.common_ship_location=response.common_ship_location + " (" + response.ship_location_code_9_digit + ")";

            }

            response.ship_to_location_gst_no=response.ship_to_location_gst_no?response.ship_to_location_gst_no:''

            if(response.ship_to_location_gst_no!='')
            {
              if(this.country_data.country_id=='101')
                  {
                    response.common_ship_location=response.common_ship_location+"(GST - "+response.ship_to_location_gst_no+")"

                  }
                  else
                  {
                    response.common_ship_location=response.common_ship_location
                  }
            }
            if(response.is_multi_grn_invoice=='0')
            {
              response.common_ship_location='';
            }
            if(response.invoice_items[0].po_no == '' || response.invoice_items[0].po_no == null || response.invoice_items[0].po_no == undefined){
              response.po_no = (response.is_multi_grn_invoice=='0' || response.is_multi_grn_invoice==false) ? response.po_no : ''
            }else{
              response.invoice_items[0].po_no = response.invoice_items[0].po_no? response.invoice_items[0].po_no : response.po_no
              response.po_no=response.is_multi_grn_invoice=='0'?response.invoice_items[0].po_no:response.po_no
            }
            if(response.invoice_items[0].po_date == '' || response.invoice_items[0].po_date == null || response.invoice_items[0].po_date == undefined){
              response.po_date = (response.is_multi_grn_invoice=='0' || response.is_multi_grn_invoice==false) ? response.po_date : ''
            }else{
              response.po_date=response.is_multi_grn_invoice=='0'?response.invoice_items[0].po_date:''
            }
            if(response.invoice_items[0].irn_cs_id == '' || response.invoice_items[0].irn_cs_id == null || response.invoice_items[0].irn_cs_id == undefined){
              response.irn_cs_id = (response.is_multi_grn_invoice=='0' || response.is_multi_grn_invoice==false) ? response.irn_cs_id : ''
            }else{
              response.irn_cs_id=response.is_multi_grn_invoice=='0'?response.invoice_items[0].irn_cs_id:''
            }
            if(response.invoice_items[0].irn_date == '' || response.invoice_items[0].irn_date == null || response.invoice_items[0].irn_date == undefined){
              response.irn_date = (response.is_multi_grn_invoice=='0' || response.is_multi_grn_invoice==false) ? response.irn_date : ''
            }else{
              response.irn_date=response.is_multi_grn_invoice=='0'?response.invoice_items[0].irn_date:''
            }
            if(response.invoice_items[0].grn_cs_id == '' || response.invoice_items[0].grn_cs_id == null || response.invoice_items[0].grn_cs_id == undefined){
              response.grn_cs_id = (response.is_multi_grn_invoice=='0' || response.is_multi_grn_invoice==false) ? response.grn_cs_id : ''
            }else{
              response.grn_cs_id=response.is_multi_grn_invoice=='0'?response.invoice_items[0].grn_cs_id:''
            }
            if(response.invoice_items[0].grn_date == '' || response.invoice_items[0].grn_date == null || response.invoice_items[0].grn_date == undefined){
              response.grn_date = (response.is_multi_grn_invoice=='0' || response.is_multi_grn_invoice==false) ? response.grn_date : ''
            }else{
              response.grn_date=response.is_multi_grn_invoice=='0'?response.invoice_items[0].grn_date:''
            }
            if(response.invoice_items[0].vendor_address == '' || response.invoice_items[0].vendor_address == null || response.invoice_items[0].vendor_address == undefined){
              response.vendor_address = (response.is_multi_grn_invoice=='0' || response.is_multi_grn_invoice==false) ? response.vendor_address : ''
            }else{
              response.vendor_address=response.is_multi_grn_invoice=='0'?response.invoice_items[0].vendor_address:response.invoice_items[0].vendor_address
            }

           
            response.is_vendor_invoice=d.is_vendor_invoice?d.is_vendor_invoice:'0';
            response.hideApproval=d.hideApproval?d.hideApproval:'0';
            if( response.is_vendor_invoice=='1')
            {
              // response.cs_id= response.invoice_cs_id? response.invoice_cs_id:''
            }
            if( response.is_vendor_invoice!='1')
            {

              response.bill_location_nickname_9_digit=response.invoice_items[0].bill_location_nickname_9_digit
              response.bill_location_code_9_digit=response.invoice_items[0].bill_location_code_9_digit;
            }
            else
            {

              response.bill_location_nickname_9_digit=response.bill_location_nickname_9_digit
              response.bill_location_code_9_digit=response.bill_location_code_9_digit;
            }
   response.ship_location_nickname_9_digit=response.invoice_items[0].ship_location_nickname_9_digit
   response.ship_location_code_9_digit=response.invoice_items[0].ship_location_code_9_digit;


            response.vendor_gst_no = response.vendor_gst_number ? response.vendor_gst_number : '';
            // console.log(response.vendor_gst_no)
            // console.log(response)
            response.requested_by = response.added_by_first_name + " " + response.added_by_last_name + " (" + response.employee_code + ")"
            response.invoice_approvals = response.grn_approvals ? response.grn_approvals : [];
            response.attachment = [];
            response.supporting_document_attachments = [];
            response.credit_note_attachments = [];
            response.attachment = this.webService.makeAttachment(response.attachments)
            response.credit_note_attachments = this.webService.makeAttachment(response.credit_note_attachment)
            response.supporting_document_attachments = this.webService.makeAttachment(response.supporting_document_attachment)
            response.extra_attachment_1 =response.supporting_document_attachments?response.supporting_document_attachments:[],
            response.extra_attachment_2 =response.credit_note_attachments?response.credit_note_attachments:[],
            response.extra_attachment_1_title =this.company_setup.custom_name_for_supporting_document?this.company_setup.custom_name_for_supporting_document:'Supporting Document';
            response.extra_attachment_2_title ='Credit Note Attachment';
            response.contractualPoAttachmentsTitle='Attach Signed Contract Copy'
            response.attachment_title = this.company_setup.custom_name_for_attachment?this.company_setup.custom_name_for_attachment:'Attachments';
            console.log(response.supporting_document_attachments);
            response.is_payment_made_disable = response.is_payment_made_disable? response.is_payment_made_disable : '0' ;
            response.approvals = response.approvals ? response.approvals : [];
            response.rejected_status = response.rejected_status ? response.rejected_status : '0';
            response.is_debit_value = response.is_debit_value ? response.is_debit_value : '0';
            if( response.is_vendor_invoice=='1' && response.rejected_status=='1')
            {
              response.approvals = [];
              response.approvals.push({
                "approval_first_name" : response.approval_first_name ? response.approval_first_name : '',
                "approval_last_name" : response.approval_last_name ? response.approval_last_name : '',
                "employee_code" : response.approval_employee_code ? response.approval_employee_code : '',
                "approval_status" : '2',
                "date_updated" : response.rejected_date ? response.rejected_date : '',
                "reason" : response.rejected_reason ? response.rejected_reason : '',
                "date_added" : response.requested_date ? response.requested_date : '',
              });
            }
          }
          else {
            this.toasterService.pop('error', "Error", data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [],"extra_attachment_2":[] };
          }
          response.id = "invoicereport";
          response.data = response;
          this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/add-invoice-v2');

          this.makeFinalData(response);
        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [],"extra_attachment_2":[] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }
  showRecurringInvoice(d) {
    this.commonVariableList.dataList = [];
    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [],"extra_attachment_2":[] };
    let is_this_invoice_no: any = '';
    let url: any = '';
    d.is_vendor_invoice=d.is_vendor_invoice?d.is_vendor_invoice:'0';
    if (d.is_this_invoice_no == '' || d.is_this_invoice_no == undefined) {
      is_this_invoice_no = '0'
      url = 'invoice/Recurring_invoice/invoiceDetails';
    }
    else if (d.is_this_invoice_no == '1') {
      is_this_invoice_no = d.is_this_invoice_no ? d.is_this_invoice_no : '1';
      url = 'invoice/Recurring_invoice/invoiceDetails';
    }
    else if (d.is_this_invoice_no == '2') {
      is_this_invoice_no = d.is_this_invoice_no ? d.is_this_invoice_no : '1';
      url = 'invoice/Recurring_invoice/invoiceDetails';
    }

    if(d.is_vendor_invoice=='1')
    {
      is_this_invoice_no = '0'
      url = 'invoice/Recurring_invoice/invoiceDetails';
    }
    if(d.is_draft=='1')
    {
      is_this_invoice_no = '0'
      url = 'invoice/Recurring_invoice/draftedInvoiceDetails';
    }
    let payload: any = {
      "drafted_invoice_id": d.drafted_invoice_id?d.drafted_invoice_id:'',
      "invoice_id": d.id, "p_type": d.p_type, 'is_this_invoice_no': is_this_invoice_no
      , "merge_grn_irn": this.company_setup.merge_grn_irn ? this.company_setup.merge_grn_irn : '0',
      is_draft:d.is_draft?d.is_draft:'0',
      is_modified:d.is_modified?d.is_modified:'0'
    }
    if(d.is_draft!='1')
    {
      delete payload['drafted_invoice_id']
    }
    else
    {
     // delete payload['invoice_id']

    }
    // console.log('hey');
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod(url, payload).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;

            if (data.response.invoice_items) {
              for (let j of data.response.invoice_items) {
                j.unit_type_name = j.unit_type_name ? j.unit_type_name : j.unit_type
                j.subcategory_name = j.subcategory_name ? j.subcategory_name : j.product_sub_category_name;
                j.product_name = j.product_name
                j.account_name=j.account_name?j.account_name:j.account_code;
              }

            }
            if(data.response.invoice_approvals)
            {
              for(let i of data.response.invoice_approvals)
              {
                i.approval_first_name=i.approval_first_name?i.approval_first_name:i.approval_by
                i.approval_last_name=i.approval_last_name?i.approval_last_name:""
                i.employee_code=i.employee_code?i.employee_code:""

              }
            }
            response = {...data.response};
            response.vendor_address=response.vendor + response.vendor_address
            response.is_vendor_invoice=d.is_vendor_invoice?d.is_vendor_invoice:'0';
            response.vendor_gst_no = response.vendor_gst_number ? response.vendor_gst_number : '';
            response.requested_by = response.requested_by
            response.invoice_approvals = response.invoice_approvals ? response.invoice_approvals : [];
            response.approvals = response.invoice_approvals ? response.invoice_approvals : [];
            response.attachment = [];
            response.supporting_document_attachments =response.supporting_document_attachments?response.supporting_document_attachments: [];
            response.attachment = this.webService.makeAttachment(response.attachments)
            response.supporting_document_attachments = this.webService.makeAttachment(response.supporting_document_attachments)
            response.extra_attachment_1 =response.supporting_document_attachments?response.supporting_document_attachments:[]
            response.extra_attachment_1_title =this.company_setup.RIT_custom_name_for_supporting_document?this.company_setup.RIT_custom_name_for_supporting_document:'Supporting Document';
            response.contractualPoAttachmentsTitle='Attach Signed Contract Copy'
            response.attachment_title = this.company_setup.RIT_custom_name_for_attachment?this.company_setup.RIT_custom_name_for_attachment:'Attachments';
            console.log(response.supporting_document_attachments);
          }
          else {
            this.toasterService.pop('error', "Error", data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          }
          response.id = "recurring_invoicereport";
          response.data = response;
          this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/create-recurring-inv');

          this.makeFinalData(response);
        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }
  showSalesInvoice(data) {
    this.commonVariableList.dataList = [];
    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
    let is_this_invoice_no: any = '';
    let url: any = '';
    if (data.is_this_invoice_no == '' || data.is_this_invoice_no == undefined) {
      is_this_invoice_no = '0'
      url = 'Sales_invoices/getInvoiceById';
    }
    else if (data.is_this_invoice_no == '1') {
      is_this_invoice_no = data.is_this_invoice_no ? data.is_this_invoice_no : '1';
      url = 'Sales_invoices/getInvoiceById';
    }
    else if (data.is_this_invoice_no == '2') {
      is_this_invoice_no = data.is_this_invoice_no ? data.is_this_invoice_no : '1';
      url = 'Sales_invoices/getInvoiceById';
    }
    let payload: any = {
      "sales_invoice_id": data.id, 'is_this_invoice_no': is_this_invoice_no
    }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod(url, payload).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;

            if (data.response.invoice_items) {
              for (let j of data.response.invoice_items) {
                j.unit_type_name = j.unit_type_name ? j.unit_type_name : j.unit_type
                j.subcategory_name = j.subcategory_name ? j.subcategory_name : j.sub_category_name;
                j.account_name = j.account_name ? j.account_name : '';
                j.account_code = j.account_code ? j.account_code : '';
                j.account_name = j.account_name + "(" + j.account_code + ")";
                j.location = data.response.ship_to_location
                if (data.response.dimension_name != undefined && data.response.dimension_name != '' && data.response.dimension_name != null) {
                  j.location = j.location + "( Dimension -" + data.response.dimension_name + " )"
                }
                j.product_name = j.product_name + " (" + j.productcode + ")";
              }

            }

            response = data.response ? data.response : {};
            response.vendor_gst_no = response.vendor_gst_number ? response.vendor_gst_number : '';
            response.added_by_first_name = response.added_by_first_name ? response.added_by_first_name : '';
            response.added_by_last_name = response.added_by_last_name ? response.added_by_last_name : '';
            response.employee_code = response.employee_code ? response.employee_code : '';

            response.approvals = response.invoice_approvals ? response.invoice_approvals : [];
            response.attachment = [];

            response.attachment = this.webService.makeAttachment(response.invoice_attachments)
          }
          else {
            this.toasterService.pop('error', "Error", data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          }
          response.id = "salesinvoicereport";
          response.data = response;
          this.makeFinalData(response);
        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }

  showDCNote(data) {
    this.commonVariableList.dataList = [];
    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
    let is_this_invoice_no: any = '';
    let url: any = '';
    if (data.is_this_invoice_no == '' || data.is_this_invoice_no == undefined) {
      is_this_invoice_no = '0'
      url = 'journal_entry/ajax_get_single_db_cr_note';
    }
    else if (data.is_this_invoice_no == '1') {
      is_this_invoice_no = data.is_this_invoice_no ? data.is_this_invoice_no : '1';
      url = 'journal_entry/ajax_get_single_db_cr_note';
    }
    else if (data.is_this_invoice_no == '2') {
      is_this_invoice_no = data.is_this_invoice_no ? data.is_this_invoice_no : '1';
      url = 'journal_entry/ajax_get_single_db_cr_note';
    }
    let payload: any = {
      "note_id": data.id?data.id:'', 'is_this_invoice_no': is_this_invoice_no,
       "company_id": this._localStorageService.getEmpCompanyId() == undefined ? '0' : this._localStorageService.getEmpCompanyId(),
    }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod(url, payload).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;



            response = Array.isArray(data.response) ? (data.response.length>0?data.response[0]:{}) : {};
            response.vendor_gst_no = response.vendor_gst_number ? response.vendor_gst_number : '';
            response.added_by_first_name = response.added_by_first_name ? response.added_by_first_name : '';
            response.added_by_last_name = response.added_by_last_name ? response.added_by_last_name : '';
            response.employee_code = response.added_by_employee_code ? response.added_by_employee_code : '';
            response.final_approval_status = response.final_approval_status ? response.final_approval_status : '0';
            if(response.approavls)
            {
              for(let i of response.approvals)
              {
                i.approval_first_name=i.first_name;
                i.approval_last_name=i.last_name;
                i.employee_code=i.employee_code?i.employee_code:'';
              }
            }
            response.approvals = response.approvals ? response.approvals : [];
            response.je_date=this.webService.formatDate(response.je_date,'dd-mm-yy','-')?this.webService.formatDate(response.je_date,'dd-mm-yy','-'):'';
            response.attachment = [];

            response.attachment = this.webService.makeAttachment(response.attachments)
          }
          else {
            this.toasterService.pop('error', "Error", data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          }
          response.id = "dcnotereport";
          response.data = response;
          this.makeFinalData(response);
        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }
  showVendorCreditNote(data) {
    this.commonVariableList.dataList = [];
    let response: any = { "extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
    let is_this_invoice_no: any = '';
    let url: any = '';
    if (data.is_this_invoice_no == '' || data.is_this_invoice_no == undefined) {
      is_this_invoice_no = '0'
      url = 'Vendor_management/ajax_db_cr_note_by_id';
    }
    else if (data.is_this_invoice_no == '1') {
      is_this_invoice_no = data.is_this_invoice_no ? data.is_this_invoice_no : '1';
      url = 'Vendor_management/ajax_db_cr_note_by_id';
    }
    else if (data.is_this_invoice_no == '2') {
      is_this_invoice_no = data.is_this_invoice_no ? data.is_this_invoice_no : '1';
      url = 'Vendor_management/ajax_db_cr_note_by_id';
    }
    let payload: any = {
      "dc_note_id": data.id ? data.id : '', 'is_this_invoice_no': is_this_invoice_no,
      "company_id": this._localStorageService.getEmpCompanyId() == undefined ? '0' : this._localStorageService.getEmpCompanyId(),
    }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod(url, payload).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;
            response = Array.isArray(data.response) ? (data.response.length > 0 ? data.response[0] : {}) : {};
            response.vendor_gst_no = response.vendor_gst_number ? response.vendor_gst_number : '';
            response.added_by_first_name = response.added_by_first_name ? response.added_by_first_name : '';
            response.added_by_last_name = response.added_by_last_name ? response.added_by_last_name : '';
            response.employee_code = response.added_by_employee_code ? response.added_by_employee_code : '';
            response.approvals = response.approvals ? response.approvals : [];
            response.je_date = this.webService.formatDate(response.je_date, 'dd-mm-yy', '-') ? this.webService.formatDate(response.je_date, 'dd-mm-yy', '-') : '';
            response.attachment = [];

            response.attachment = this.webService.makeAttachment(response.attachments)
          }
          else {
            this.toasterService.pop('error', "Error", data.message);
            response = { "extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          }
          response.id = "creditnotereport";
          response.data = response;
          this.makeFinalData(response);
        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          response = { "extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }
  showMyAdvance(data) {

    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
    let payload: any = { "id": data.id ? data.id : '' }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod('project/My_advance_master/get_all_advance_by_id', data).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;
            response = data.response[0] ? data.response[0] : {};
            response.attachment = this.webService.makeAttachment(response.advance_attachment) ? this.webService.makeAttachment(response.advance_attachment) : []
            response.project_details = response.project_name + "(" + response.project_code + ")";
            response.added_by = response.first_name + " " + response.last_name + "(" + response.employee_code + ")";
            response.added_for = response.advance_employee_first_name + " " + response.advance_employee_last_name + "(" + response.advance_employee_code + ")";
            response.is_reimburshable = response.is_reimburshable == '1' ? 'YES' : 'NO';
            response.items = [];
            response.advance_type = response.advance_type_name + "(" + response.advance_type_code + ")";
            response.items.push(
              {
                'sl_no': '1', 'advance_type': response.advance_type, 'from_date': response.from_date, 'to_date': response.to_date,
                'advance_amount': response.advance_amount, 'is_reimburshable': response.is_reimburshable,
                'attachment': response.attachment ? response.attachment : [], 'remarks': response.remarks
              }
            )
            if (response.advance_approvals) {
              for (let i of response.advance_approvals) {
                i.approval_first_name = i.approval_by_first_name
                i.approval_last_name = i.approval_by_last_name
                i.employee_code = i.approval_employee_code;
                i.reason = i.reason ? i.reason : '';

              }
            }



            response.approvals = []
            response.approvals = response.advance_approvals ? response.advance_approvals : [];

          }
          else {
            this.toasterService.pop('error', "Error", data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          }
          response.id = "my_advance_report";
          response.data = response;
          this.makeFinalData(response);
        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }
  showEmployeeAdvancePayment(data) {

    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
    let payload: any = { "id": data.id ? data.id : '' }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod('project/My_advance_master/get_all_advance_payment_by_id', data).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;
            response = data.response[0] ? data.response[0] : {};
            // response.attachment = this.webService.makeAttachment(response.advance_attachment) ? this.webService.makeAttachment(response.advance_attachment) : []
            response.bank_details = response.bank_name + "(" + response.account_no + ")";
            response.added_by = response.added_by_first_name + " " + response.added_by_last_name + "(" + response.added_by_employee_code + ")";
            // response.added_for=response.advance_employee_first_name+" "+response.advance_employee_last_name+"("+response.advance_employee_code+")";
            // response.is_reimburshable=response.is_reimburshable=='1'?'YES':'NO';
            response.items = [];
            // response.advance_type=response.advance_type_name+"("+response.advance_type_code+")";
            response.items.push(
              {
                'sl_no': '1', 'advance_amount': response.advance_amount, 'payble_amount': response.payble_amount,
                'retention_amount': response.retention_amount, 'date_of_payment': response.date_of_payment,
                'bank_details': response.bank_details, 'remarks': response.remarks
              }
            )
            if (response.approvals) {
              for (let i of response.approvals) {
                i.approval_first_name = i.approval_first_name
                i.approval_last_name = i.approval_last_name
                i.employee_code = i.approval_by_employee_code;
                i.reason = i.reason ? i.reason : '';

              }
            }




          }
          else {
            this.toasterService.pop('error', "Error", data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          }
          response.id = "employee_advance_payment_report";
          response.data = response;
          this.makeFinalData(response);
        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }
  makeFinalData(response) {
    let c = 1;
    for(let i of response.approvals) {
      i.employee_level = i.employee_level ? i.employee_level : c;
      c++;
    }

    this.commonVariableList.dataList.push(response)
    this.commonVariableList.beforedivList = response.beforedivList ? response.beforedivList : []
    this.commonVariableList.afterdivList = response.afterdivList ? response.afterdivList : []
    this.commonVariableList.modalDetails.is_view = true;
    this.commonVariableList.isProgressing = false;

    this.commonVariableList.afterDivDetails = {};
    this.commonVariableList.afterDivDetails = response;
    this.commonVariableList.beforeDivDetails = {};
    this.commonVariableList.beforeDivDetails = response;
    this.commonVariableList.tableDetails = {};
    this.commonVariableList.tableDetails = response;
    this.commonVariableList.approvalDetails = {};
    this.commonVariableList.approvalDetails = response;
    this.commonVariableList.attachments = [];
    this.commonVariableList.attachments = response.attachment ? response.attachment : [];
    this.commonVariableList.extra_attachment_1_title=response.extra_attachment_1_title?response.extra_attachment_1_title:'';
    this.commonVariableList.extra_attachment_2_title=response.extra_attachment_2_title?response.extra_attachment_2_title:'';
    this.commonVariableList.contractualPoAttachmentsTitle='Attach Signed Contract Copy'
    this.commonVariableList.attachment_title_qc=response.attachment_title_qc?response.attachment_title_qc:'';
    this.commonVariableList.contractualPoAttachmentsTitle='Contract PO Attachment'
    this.commonVariableList.attachment_title=response.attachment_title?response.attachment_title:'';

    this.commonVariableList.po_additional_attachments = response.po_additional_attachment ? response.po_additional_attachment : [];
    this.commonVariableList.po_additional_attachments_title = response.po_additional_attachment ?  response.po_additional_attachments_title:''
    
    this.commonVariableList.pr_attachments = []

    this.commonVariableList.pr_attachments = this.webService.makeAttachment( response.pr_attachments) ? this.webService.makeAttachment( response.pr_attachments) : []
    this.commonVariableList.afterDivDetails.is_setup=true;
    this.commonVariableList.afterDivDetails.setup=this.comanySetup.getData();

    this.commonVariableList.beforeDivDetails.is_setup=true;
    this.commonVariableList.beforeDivDetails.setup=this.comanySetup.getData();


    this.commonVariableList.tableDetails.is_setup=true;
    this.commonVariableList.tableDetails.setup=this.comanySetup.getData();

    this.commonVariableList.approvalDetails.is_setup=true;
    this.commonVariableList.approvalDetails.setup=this.comanySetup.getData();

    // Setup allocableCostDetails
    this.setupAllocableCostDetails();


    this.commonVariableList.extra_attachment_1 = response.extra_attachment_1 ? response.extra_attachment_1 : [];
    this.commonVariableList.extra_attachment_2 = response.extra_attachment_2 ? response.extra_attachment_2 : [];
    this.commonVariableList.extra_attachment_qc = response.extra_attachment_qc ? response.extra_attachment_qc : [];
    this.commonVariableList.contractualPoAttachments = response.contractualPoAttachments ? response.contractualPoAttachments : [];
    this.commonVariableList.fulfilled_po_upload_invoice = response.fulfilled_po_upload_invoice ? response.fulfilled_po_upload_invoice : [];
    this.commonVariableList.fulfilled_po_upload_invoice_title = response.fulfilled_po_upload_invoice_title ? response.fulfilled_po_upload_invoice_title : '';
    this.commonVariableList.fulfilled_po_vendor_attachment = response.fulfilled_po_vendor_attachment ? response.fulfilled_po_vendor_attachment : [];
    this.commonVariableList.fulfilled_po_vendor_attachment_title = response.fulfilled_po_vendor_attachment_title ? response.fulfilled_po_vendor_attachment_title : '';
  }
  initListener() {
    document.body.addEventListener('keypress', (event) => this.reset(event));
    document.body.addEventListener('keydown', (event) => this.reset(event));
    document.body.addEventListener('keyup', (event) => this.reset(event));

  }
  reset(event) {
    if (event.keyCode == '27') {
      this.modalDetails.is_view = false;
      document.body.style.overflow = 'auto';
    }
  }
  getDraftInvoiceData(temp) {
    let requestObj = {
      "company_id": this._localStorageService.getEmpCompanyId() == undefined ? "0" : this._localStorageService.getEmpCompanyId(),
      "drafted_invoice_id": temp.drafted_invoice_id ? temp.drafted_invoice_id : '',
      "invoice_id": temp.id ? temp.id : '',
      is_draft: '1',
      is_this_invoice_no: '0'
    }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod("invoice/Recurring_invoice/draftedInvoiceDetails", requestObj).
      subscribe(
        data => {
          if (data.status) {
            this.raiseInvoice(data.response,temp)
          }
          this.commonVariableList.isProgressing = false;
        },
        error => {
          this.commonVariableList.isProgressing = false;
        }
        )
      }
  raiseInvoice(data:any,temp)
  {
    this.hideModal()
    let a:any={'action_type':'recurring_copy','drafted_invoice_id':temp.drafted_invoice_id?temp.drafted_invoice_id:'','draft_invoice_id':temp.drafted_invoice_id?temp.drafted_invoice_id:'','invoice_id':temp.id?temp.id:'','is_draft':'1','invoice_no':data.vendor_invoice_no?data.vendor_invoice_no:'',
    'vendor_id':data.vendor_id?data.vendor_id:'','vendor_location_id':data.vendor_location_id?data.vendor_location_id:''}
localStorage.setItem('direct-invoice',this.eesdesService.set(JSON.stringify((a))));
this.webService.redirectURL('/raise-recurring-direct-invoice');
  }

  showRfqData(data, type) {
    this.commonVariableList.dataList = [];
    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
    let is_this_invoice_no: any = '';
    let payload: any = {
      "rfq_id": data.rfq_id?data.rfq_id:'',
       "company_id": this._localStorageService.getEmpCompanyId() == undefined ? '0' : this._localStorageService.getEmpCompanyId(),
       "is_report": "1"
    }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod('/Vendor_management/ajax_view_rfq_id', payload).subscribe(data => {
      if (data.status) {
        let index: number = 0;
        response = Array.isArray(data.response) ? (data.response.length>0?data.response[0]:{}) : {};
        if(response.rfq_approvals){
          for(let i of response.rfq_approvals){
            i.approval_first_name=i.approval_first_name;
            i.approval_last_name=i.approval_last_name;
            i.employee_code=i.employee_code?i.employee_code:'';
          }
        }
        response.attachment_title = this.getColumnNameQuotationManagement('rfq_documents','Uploaded RFQ Documents');
        response.attachments = response.rfq_attachments ? response.rfq_attachments : [];
        response.rfq_approvals = response.rfq_approvals ? response.rfq_approvals : [];
        response.attachment = this.webService.makeAttachment(response.attachments)
        let cost_center_budget_details_obj = {
          "annual_budget_amount": '',
          "budget_consumed_till_date": '',
          "current_amount_rfq": '',
          "balance_budget": '',
        }
        response.cost_center_budget_details_obj = response.cost_center_budget_details_obj ? response.cost_center_budget_details_obj : cost_center_budget_details_obj;
      }
      else {
        this.toasterService.pop('error', "Error", data.message);
        response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
      }
      response.id = type;
      response.data = response;
      this.makeFinalData(response);
    },error => {
      this.toasterService.pop("Error", "Something Went Wrong")
      response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
      this.commonVariableList.isProgressing = false;
    });
  }

  getColumnNameQuotationManagement(key, default_data) {
    if (key == '' || key == undefined) {
      return default_data ? default_data : '-';
    }
    if (this.company_setup.quotation_management_master_column_list.length == undefined || this.company_setup.quotation_management_master_column_list.length <= 0) {
      return default_data ? default_data : '-';

    }
    let temp: any = [];
    temp = this.company_setup.quotation_management_master_column_list.filter((v) => { return v.key == key });
    if (temp.length == undefined || temp.length <= 0) {
      return default_data ? default_data : '-';
    }
    return temp[0].custom_name ? temp[0].custom_name : '-'
  }
  getApprovedInvoicePdf() {
    const html2canvas: any = _html2canvas;
    const modalContent = document.querySelector('.modal-content') as HTMLElement;
    const originalMaxHeight = modalContent.style.maxHeight;
    if(modalContent){
      this.commonVariableList.isProgressing = true;
    }
    // Temporarily remove max-height
    modalContent.style.maxHeight = 'none';

    html2canvas(modalContent, {
      scale: window.devicePixelRatio,
      useCORS: true,
      allowTaint: true,
      logging: true,
    }).then(canvas => {
      // Restore the original max-height
      modalContent.style.maxHeight = originalMaxHeight;

      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const imgWidth = 208; // A4 size in mm
      const pageHeight = 295; // A4 size in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      this.commonVariableList.isProgressing = false
      pdf.save('Invoice_Data.pdf');
    }).catch(error => {
      this.commonVariableList.isProgressing = false
      console.error('Error capturing content:', error);
    });
  }
  isVisibled(key)
  {
    return this.company_setup.vendor_invoice_column_list.some((v)=>{return v.id==key && v.isVisible})
  }

  /**
   * Setup allocableCostDetails similar to tableDetails
   */
  setupAllocableCostDetails() {
    this.commonVariableList.allocableCostDetails = {};
    this.commonVariableList.allocableCostDetails.id = this.modalDetails.id || 'poreport';
    this.commonVariableList.allocableCostDetails.lines = this.commonVariableList.allocableCostLines || [];
    this.commonVariableList.allocableCostDetails.viewContext = (this.commonVariableList.tableDetails && this.commonVariableList.tableDetails.data) ? this.commonVariableList.tableDetails.data : {};
    this.commonVariableList.allocableCostDetails.caption = 'Additional Cost Line items (Not Part of Vendor PO)';
    this.commonVariableList.allocableCostDetails.is_setup = true;
    this.commonVariableList.allocableCostDetails.setup = this.comanySetup.getData();
    this.commonVariableList.allocableCostDetails.is_view = this.isAllocableCostTableVisible();
  }

  /**
   * Check if allocable cost table should be visible (main view)
   */
  isAllocableCostTableVisible(): boolean {
    return this.modalDetails.id === 'poreport' 
           && this.commonVariableList.is_allocable_cost 
           && this.company_setup.enable_allocable_cost_direct_po == '1' 
           && this.commonVariableList.allocableCostLines 
           && this.commonVariableList.allocableCostLines.length > 0;
  }

  /**
   * Check if allocable cost table should be visible for history item
   */
  isAllocableCostTableVisibleForHistory(item: any): boolean {
    return this.modalDetails.id === 'poreport' 
           && (item.is_allocable_cost == '1' || item.is_allocable_cost == 1 || item.is_allocable_cost == true)
           && this.company_setup.enable_allocable_cost_direct_po == '1' 
           && item.allocable_cost_items 
           && item.allocable_cost_items.length > 0;
  }

  getTotalCostLineAmount(currencyType: string): number {
    if (!this.commonVariableList.allocableCostLines || this.commonVariableList.allocableCostLines.length === 0) {
      return 0;
    }
    let total = 0;
    for (let costLine of this.commonVariableList.allocableCostLines) {
      if (currencyType === 'po_currency') {
        total += parseFloat(this.webService.convertNaN(costLine.planned_amount_in_po_currency)) || 0;
      } else {
        total += parseFloat(this.webService.convertNaN(costLine.planned_amount_in_base_currency)) || 0;
      }
    }
    return total;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src2008182461/src/src/app/generic-ui-components/generic-modal-popup/generic-modal-popup.component.ts